import { useEffect, useState } from 'react';
import Select from '@/atoms/inputs/Select/Select';
import { useScenarioContext, useViewModeContext } from '@/shared/providers';
import { EntityName } from '@enums/EntityName';
import { EntityMetric } from '@/lib/enums';
import MetricOptions from './MetricOptions';

const DEFAULT_OPTIONS = [
  EntityMetric.ENTITY_PERCENTAGE,
  EntityMetric.RELATIVE_PERCENTAGE,
  EntityMetric.PERCENTAGE,
  EntityMetric.HOURS,
  EntityMetric.BUDGET,
  EntityMetric.FTE,
];

const MetricTypeSelect = ({
  options = DEFAULT_OPTIONS,
  initialMetric,
  onChange,
}) => {
  const viewMode = useViewModeContext();
  const showBudget = viewMode?.showBudget;
  const { scenario } = useScenarioContext();
  const metricOptions = options
    .filter(
      (id) =>
        showBudget ||
        (!showBudget &&
          id !== EntityMetric.BUDGET &&
          id !== EntityMetric.COST &&
          id !== EntityMetric.ACTIVITY_BUDGET)
    )
    .map((id) => {
      if (id === EntityMetric.PERCENTAGE) {
        const entityName = scenario?.entity.is_manager
          ? 'managed'
          : EntityName[scenario?.entity?.__type];

        return {
          ...MetricOptions[id],
          label: `% of ${entityName?.toLowerCase()}`,
        };
      }
      return MetricOptions[id];
    });

  const [selected, setSelected] = useState(
    metricOptions.find(({ id }) => id === initialMetric) ?? metricOptions[0]
  );

  const handleChange = (metric) => {
    setSelected(metric);
    onChange?.(metric);
  };

  // This effect resets the metric selection if it's set to budgets and the
  // showBudget permission is removed.
  useEffect(() => {
    if (!showBudget && selected.id === EntityMetric.BUDGET) {
      setSelected(metricOptions[0]);
    }
  }, [showBudget]);

  return (
    <Select
      initialValue={selected}
      label="Metric type"
      onChange={handleChange}
      options={metricOptions}
      optionLabel="label"
    />
  );
};

export default MetricTypeSelect;
